export const STORE_KEY = 'time';
